import { Box } from "@mui/system";
import React from "react";
import { useTheme } from "@emotion/react";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import PauseRoundedIcon from "@mui/icons-material/PauseRounded";
import { useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";

import {
  getPlayerState,
  setMinimizePlayer,
  setMinimizePlayerBackUrl,
  setPlayAll,
  setPlaying,
  setTopicData,
  setUrl,
} from "../../../../redux/features/playerSlice";
import CustomCircleButton from "../../CustomCircleButton";

const PlayAllButton = () => {
  const location = useLocation();
  const { playAll, topicData, playList } = useSelector(getPlayerState);
  const dispatch = useDispatch();

  const theme = useTheme();
  const handlePlayAll = () => {
    if (topicData) {
    } else {
      dispatch(
        setMinimizePlayerBackUrl(
          location.pathname + "/topics/" + playList[1].pk
        )
      );
      dispatch(setUrl(playList[0].file));
      dispatch(setTopicData(playList[0]));
    }
    dispatch(setPlayAll(!playAll));
    dispatch(setPlaying(!playAll));
    dispatch(setMinimizePlayer(true));
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <CustomCircleButton
        disabled={playList.length === 0}
        onClick={handlePlayAll}
        width='40px'
        height='40px'
        bgColor='primary.main'
        hoverBgColor='primary.main'
        hoverColor='black'
        bShadow={`0px 2px 0px ${theme.palette.black.main}`}
        activeBgColor='black.main'
        activeColor='white.main'
      >
        {playAll ? (
          <PauseRoundedIcon sx={{ fontSize: "26px" }} />
        ) : (
          <PlayArrowRoundedIcon sx={{ fontSize: "26px" }} />
        )}
      </CustomCircleButton>
    </Box>
  );
};

export default PlayAllButton;
